import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { MERZ_ROUTES } from 'src/app/merz-routes';
import { UserDetailService } from '../../user-detail-service/user-detail.service';

@Injectable({
  providedIn: 'root',
})
export class UltherapyPrimeGuard {
  constructor(
    private userDetailService: UserDetailService,
    private navController: NavController
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.userDetailService.userDetail?.isUltherapyPrime === true) {
      return true;
    } else {
      this.navController.navigateRoot([MERZ_ROUTES.homeComplete]);
      return false;
    }
  }
}
